module.exports = __webpack_public_path__ + "img/8.6b06a39f.png";